import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";
import "src/services/styles/sweetAlert.css"


export const getCuentasParametros = async (id_cuentas) => {
    const cuentas_parametros = new datos("cuentas_parametros");
    cuentas_parametros.addCondition("cuentas_parametros", "id", 0, ">");
    cuentas_parametros.addCondition("cuentas_parametros", "id_cuentas", parseInt(id_cuentas), "=")
    const response = await cuentas_parametros.get();
    return esArray(response.wsResponse.cuentas_parametros);
};

export const getCuentasParametrosPaginated = async (limit, offset, id_cuentas) => {
    const cuentas_parametros = new datos("cuentas_parametros");
    cuentas_parametros.addCondition("cuentas_parametros", "id", 0, ">");
    cuentas_parametros.join("parametros_cuentas", "id", "id_parametros_cuentas", "=");
    cuentas_parametros.addCondition("cuentas_parametros", "id_cuentas", parseInt(id_cuentas), "=");
    cuentas_parametros.addLimitCondition(limit, offset);

    const response = await cuentas_parametros.get();

    // Asegurar que 'response' y 'wsResponse' existen y tienen datos
    const data = esArray(response.wsResponse?.cuentas_parametros);
    let result = {};

    if (!response.wsResponse?.empty) {
        // Procesar datos para mover 'nombre' de 'parametros_cuentas' al nivel superior
        const processedData = data.map((item) => {
            // Extraer 'nombre' de 'parametros_cuentas'
            const nombre = item.relations?.parametros_cuentas?.nombre || "";

            // Crear un nuevo objeto con 'nombre' al mismo nivel que 'id_parametros_cuentas'
            return {
                ...item,
                nombre_parametros_cuentas: nombre, // Añadir el 'nombre' aquí
                relations: undefined, // Eliminar el nodo 'relations' si no es necesario
            };
        });

        result = {
            data: processedData,
            total_records: response.wsResponse.total_records,
        };
    } else {
        // Manejar el caso cuando no hay datos o está vacío
        result = {
            data: [],
            total_records: 0,
        };
    }

    return result;
};


export const deleteCuentasParametros = async (id) => {
    let status = false;
    await Swal.fire({
        title: "¿Está seguro de que desea eliminar este registro?",
        text: "Si sigue adelante, no se podrán revertir los cambios.",
        icon: "warning",
        showCancelButton: true,
        customClass: {
            container: 'my-swal-delete'
        },
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, quiero eliminarlo",
        cancelButtonText: "No, no estoy seguro",
    }).then(async (result) => {
        if (result.isConfirmed) {
            const cuentas_parametros = new datos("cuentas_parametros");
            let data = {
                id: id,
            };
            const response = await cuentas_parametros.delete(data);

            if (response.status === "true") {
                status = true;
                await Swal.fire({
                    customClass: {
                        container: 'my-swal-delete'
                    },
                    title: "¡Eliminado!",
                    text: "El registro ha sido eliminado exitosamente",
                    icon: "success"
                });
            } else {
                await Swal.fire({
                    customClass: {
                        container: 'my-swal-delete'
                    },
                    icon: "error",
                    title: "¡Oops!",
                    text: response.message,
                });
            }
        }
    });
    return status;
};

